import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/features/blog/blog-details/components/BlogDetails.tsx");
